import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, onWheel, ...props }, ref) => {
    // Sprint 3 (S3.A): native `<input type="number">` increments on mouse
    // wheel by default. That's a long-standing UX trap for salary / cap
    // numeric fields — recruiters scroll the page and inadvertently change
    // the value sitting under their cursor. We blur the input so the wheel
    // event falls through to page scroll instead. Callers can still pass
    // their own `onWheel` to override (we run theirs first, then blur).
    const handleWheel = React.useCallback(
      (e: React.WheelEvent<HTMLInputElement>) => {
        onWheel?.(e);
        if (type === 'number' && !e.defaultPrevented) {
          (e.currentTarget as HTMLElement).blur();
        }
      },
      [type, onWheel],
    );

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        onWheel={handleWheel}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
